import { forwardRef, PropsWithChildren } from 'react'
import styled, { css } from 'styled-components'
import { desktopCSS } from '@measures/responsive'

export type VideoWrapperProps = {
  hasPlaylist?: boolean
}

const StyledVideoWrapper = styled.div<VideoWrapperProps>`
  ${({ hasPlaylist }) => {
    // creating place for playlist on the right side of video
    const hasPlaylistCSS = css`
      ${desktopCSS(css`
        grid-column-end: span 4;
      `)}
    `

    return css`
      ${hasPlaylist && hasPlaylistCSS}
    `
  }}
`

const VideoWrapper = forwardRef<
  HTMLDivElement,
  PropsWithChildren<VideoWrapperProps>
>(({ hasPlaylist, children }, ref) => {
  return (
    <StyledVideoWrapper ref={ref} hasPlaylist={hasPlaylist}>
      {children}
    </StyledVideoWrapper>
  )
})

VideoWrapper.displayName = 'VideoWrapper'

export default VideoWrapper
